import { render, staticRenderFns } from "./popup-payment.vue?vue&type=template&id=47c824cc&"
import script from "./popup-payment.vue?vue&type=script&lang=js&"
export * from "./popup-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports